import * as React from 'react';
import {useState} from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';

import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {withRouter} from 'react-router';
import Button from '@material-ui/core/Button';

import {GlobalCss} from 'components/global-css.js';
import {ErrorMessage} from 'components/ErrorMessage.js';
import {DateUtil} from 'utils/date-util.js';
import EartagDroppedSensorSummarizerTask from './component/EartagDroppedSensorSummarizerTask.js';
import EartagReanalysisImportTask from './component/EartagReanalysisImportTask.js';

const styles = {
  flexContainer: GlobalCss.flexContainer,
  leftJustifiedIitem: GlobalCss.leftJustifiedIitem,
  rightJustifiedIitem: GlobalCss.rightJustifiedIitem,
};

const reanalysisTasks = [
  'eartag_activity_reanalysis_importer:run',
  'eartag_activity_reanalysis_importer_parallel:run'
];

const EartagEcsTasksIndex = (props) => {
  const [taskName, setTaskName] = useState('');
  const [loopCount, setLoopCount] = useState('');
  const [notes, setNotes] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [endDate, setEndDate] = useState(null);

  const env = process.env.REACT_APP_ENVIRONMENT || 'local';

  const createParams = () => {
    return {
      pathname: '/eartag_ecs_tasks/confirm',
      state: {
        taskName: taskName,
        loopCount: loopCount,
        notes: notes,
        endDate: endDate,
        environment: env
      }
    };
  };

  const createAction = () => {
    const result = validate();
    if (!result.valid) {
      setErrorMessage(result.errors.join('\n'));
      return;
    } else {
      setErrorMessage('');
    }
    props.history.push(createParams());
  };

  const validate = () => {
    const errors = [];

    if (!taskName) {
      errors.push('タスク名称を選択して下さい');
    }

    if (taskName === 'eartag_dropped_sensor_summarizer:run') {
      const today = DateUtil.today();
      if (endDate > today) {
        errors.push('終了日: 未来の日付は指定できません');
      }

      const startOfMonth = DateUtil.startOfMonth(today);
      if (endDate < startOfMonth) {
        errors.push('終了日: 先月以前の日付は指定できません');
      }
    }

    return {valid: errors.length === 0, errors: errors};
  };

  const isReanalysisTask = reanalysisTasks.includes(taskName);
  const isDisabled = taskName === '';

  return (
    <div style={{marginLeft: '20px'}}>
      <h2>[イヤタグ]ECSタスク実行</h2>
      {env === '本番' && <div style={{color: 'red', fontWeight: 'bold'}}>[注意]本番環境のデータが更新されます</div>}

      <div style={{marginLeft: '40px'}}>
        <ErrorMessage errorMessage={errorMessage} />
      </div>

      <ul className={props.classes.flexContainer}>
        <li>
          <InputLabel htmlFor="ecs-tasks" style={{fontSize: 16, marginLeft: 40, marginBottom: 20, marginTop: 20}}>ECSタスク名称</InputLabel>
          <Select
            inputProps={{name: 'ecs-tasks', id: 'ecs-tasks'}}
            style={{minWidth: 680, marginLeft: 40, marginBottom: 20}}
            onChange={(e) => setTaskName(e.target.value)}
            value={taskName}
          >
            <MenuItem value={'eartag_activity_reanalysis_importer:run'}>活動量分析結果の取り込み(eartag_activity_reanalysis_importer:run)</MenuItem>
            <MenuItem value={'eartag_activity_reanalysis_importer_parallel:run'}>[並列処理版] 活動量分析結果の取り込み(eartag_activity_reanalysis_importer_parallel:run)</MenuItem>
            <MenuItem value={'eartag_dropped_sensor_summarizer:run'}> イヤタグ脱落アラート集計(eartag_dropped_sensor_summarizer:run)</MenuItem>
            <MenuItem value={'eartag_anomaly_sensor:detect'}> 異常イヤタグセンサー検出(eartag_anomaly_sensor:detect)</MenuItem>
            {env !== '本番' && (<MenuItem value={'LegacyLinkJob'}>活動量グラフの再生成(LegacyLinkJob)</MenuItem>)}
          </Select>
        </li>

        <li style={{marginLeft: '100px'}}>
          <Button variant="contained" color="primary" onClick={() => createAction()} disabled={isDisabled}>
            実行
          </Button>
        </li>
      </ul>

      {isReanalysisTask && (
        <EartagReanalysisImportTask
          loopCount={loopCount}
          setLoopCount={setLoopCount}
          classes={props.classes}
        />
      )}

      {taskName === 'eartag_dropped_sensor_summarizer:run' && (
        <EartagDroppedSensorSummarizerTask
          endDate={endDate}
          setEndDate={setEndDate}
          classes={props.classes}
        />
      )}

      <ul className={props.classes.flexContainer} style={{marginLeft: 40, marginBottom: 20}}>
        <li>
          <TextField
            type="text"
            label="備考"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            variant="outlined"
            margin="dense"
            fullWidth={true}
            className={props.classes.textAreaField}
            multiline
            rows={5}
            style={{width: 500}}
          />
        </li>
      </ul>
    </div>
  );
};

EartagEcsTasksIndex.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const forExport = withRouter(withStyles(styles)(EartagEcsTasksIndex));
export {forExport as EartagEcsTasksIndex};
